<highcharts-chart
  [Highcharts]="Highcharts"
  [options]="chart"
  style="height: 100%; width: 100%; display: block"></highcharts-chart>
